import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SubmitButton from "../Common/buttons/SubmitButton";
import { ApiHook } from "../../hooks/apiHook";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { ReplicaService } from "../../services/replica/replica";

const KycTab = ({ kyc, kycStatus, email, emailVerified }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const {
    register,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      panName: kyc?.panName ?? "",
      panNumber: kyc?.panNumber ?? "",
      aadharNumber: kyc?.aadharNumber ?? "",
      gstin: kyc?.gstin ?? "",
      email: email ?? ""
    },
  });

  const formValues = watch();
  const [isEditModeEnabled, setIsEditModeEnabled] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const [documents, setDocuments] = useState({
    pan: {
      file: kyc?.panImg ?? null,
      name: kyc?.panImg?.split("/").pop().split("-").slice(1).join("-") ?? "",
      data: null,
    },
    aadhaar: {
      file: kyc?.aadhaarImg ?? null,
      name:
        kyc?.aadhaarImg?.split("/").pop().split("-").slice(1).join("-") ?? "",
      data: null,
    },
    bankPassbook: {
      file: kyc?.bankPassbookImg ?? null,
      name:
        kyc?.bankPassbookImg?.split("/").pop().split("-").slice(1).join("-") ??
        "",
      data: null,
    },
    signature: {
      file: kyc?.signatureImg ?? null,
      name:
        kyc?.signatureImg?.split("/").pop().split("-").slice(1).join("-") ?? "",
      data: null,
    },
    gstin: {
      file: kyc?.gstinImg ?? null,
      name: kyc?.gstinImg?.split("/").pop().split("-").slice(1).join("-") ?? "",
      data: null,
    },
  });

  const updateKycMutation = ApiHook.CallUpdateKycDetails(formValues);
  const sendEmailVerification = ReplicaService.useSendVerificationCode();
  const verifyEmail = ReplicaService.useVerifyEmail();
  const checkEmail = ReplicaService.useCheckEmail();

  const isKycPending =
    kyc?.aadhaarStatus === "2" &&
    kyc?.panStatus === "2" &&
    kyc?.bankPassbookStatus === "2";

  const toggleEditMode = () => {
    setIsEditModeEnabled(!isEditModeEnabled);
  };

  const handleSubmit = async () => {
    const isValid = await trigger();
    if (
      (kyc?.aadhaarStatus !== "1" && kyc?.aadhaarStatus !== "2" && !documents.aadhaar.data) ||
      (kyc?.panStatus !== "1" && kyc?.panStatus !== "2" && !documents.pan.data) ||
      (kyc?.bankPassbookStatus !== "1" && kyc?.bankPassbookStatus !== "2" && !documents.bankPassbook.data)
    ) {
      toast.error("please upload required documents, documents are mandatory (Aadhaar, PAN, Bank Passbook)");
      return;
    }

    if(!emailVerified) {
      if(!verifyEmail.data?.status ){
      toast.error("email is not Verified" );
      return
      }
    }
    const forms = {
      formValues,
      files: [
        documents.aadhaar.data,
        documents.pan.data,
        documents.bankPassbook.data,
        documents.signature.data,
        documents.gstin.data,
      ],
    };
    if (isValid) {
      updateKycMutation.mutate(forms, {
        onSuccess: (res) => {
          if(!res?.status){
            toast.error(t(res?.data?.description));
            return;
          }
          queryClient.invalidateQueries({ queryKey: ["profile"] });
          toast.success(t(res?.data));
          setIsEditModeEnabled(false);
        },
      });
    }
  };

  const handleFileChange = (e, docType) => {
    const file = e.target.files[0];
    if (file) {
      setDocuments((prev) => ({
        ...prev,
        [docType]: {
          file: URL.createObjectURL(file),
          name: file.name,
          data: file,
        },
      }));
    }
  };

      const sendVerificationCode = async () => {
        if(!formValues.email){
          toast.error("Please enter a valid email");
          return;
        }
        

        //mutate email check
        const checkEmailExist = await checkEmail.mutateAsync(formValues.email)
        if(!checkEmailExist.status){
          toast.error("Email Already exists");
          return;
        }

        sendEmailVerification.mutate(formValues.email, {
          onSuccess: (res) => {
            if(res.status){
              toast.success("Verification code sent successfully");
              setIsOtpSend(true);
            } else {
              toast.error(res.description);
            }
          },
          onError: (error) => {
            console.error("Failed to send verification code", error);
          },
        });
      };


    const handleVerificationCodeChange = (event) => {
      // setVerificationCode(event.target.value);
      if(event.target.value.length === 6){
        verifyEmail.mutate({email: formValues.email, otp: event.target.value}, {
          onSuccess: (res) => {
            if(res.status){
              toast.success("Email verified successfully");
              setIsOtpSend(false);
            }else{
              toast.error(res.description);
            }
          },
          onError: (error) => {
            console.error("Failed to verify email", error);
          },
        });
      }
    };

  return (
    <div id="thirdTab" className="tabcontent">
      {kycStatus != 1 && !isKycPending && (
        <div className={`editSec ${isEditModeEnabled ? "disabled" : ""}`}>
          <div className="editBg">
            <span
              style={{ textDecoration: "none", cursor: "pointer" }}
              onClick={toggleEditMode}
            >
              <i
                className="fa-solid fa-pen-to-square"
                style={{ color: "#32009c" }}
              ></i>
            </span>
          </div>
        </div>
      )}
      <h3>KYC Details</h3>
      <div className="tabcontent_form_section" style={{maxWidth: "750px"}}>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="panName"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            Pan Name:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <input
              {...register(
                "panName" /* , {
                required: t("this_field_is_required"),
                validate: (value) =>
                  value.trim() !== "" || t("this_field_is_required"),
              } */
              )}
              name="panName"
              type="text"
              className="form-control"
              style={{ width: "52.3%" }}
              id="panName"
              defaultValue={formValues?.panName}
              disabled={!isEditModeEnabled}
            />
            {errors.panName && (
              <span className="validation-error-message">
                {errors.panName.message}
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="panNumber"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            <label style={{ color: "red" }}>*</label> Pan Number:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <div className="d-flex flex-wrap align-items-start gap-2">
              <div className="flex-grow-1">
                <input
                  {...register("panNumber", {
                    required: t("this_field_is_required"),
                    pattern: {
                      value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                      message: "Invalid Pan Format",
                    },
                  })}
                  name="panNumber"
                  type="text"
                  className="form-control w-100"
                  id="panNumber"
                  defaultValue={formValues?.panNumber}
                  disabled={!isEditModeEnabled}
                />
              </div>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="pan-upload"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "pan")}
                />
                <label
                  htmlFor="pan-upload"
                  style={{
                    cursor:
                      !isEditModeEnabled ||
                      kyc?.panStatus === "1" ||
                      kyc?.panStatus === "2"
                        ? "not-allowed"
                        : "pointer",
                    padding: "6px 20px",
                    background:
                      !isEditModeEnabled ||
                      kyc?.panStatus === "1" ||
                      kyc?.panStatus === "2"
                        ? "gray"
                        : "#954cea",
                    color: "#fff",
                    borderRadius: "5px",
                    opacity:
                      !isEditModeEnabled ||
                      kyc?.panStatus === "1" ||
                      kyc?.panStatus === "2"
                        ? 0.6
                        : 1,
                    pointerEvents:
                      !isEditModeEnabled ||
                      kyc?.panStatus == "1" ||
                      kyc?.panStatus === "2"
                        ? "none"
                        : "auto",
                  }}
                >
                  <i class="fa-solid fa-upload"></i>
                </label>
              </div>
              {documents.pan.file && (
                <>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={documents.pan.file}
                      style={{ width: "36px", height: "auto" }}
                    />
                    <p className="mt-2">
                      {documents.pan.name.length > 20
                        ? `${documents.pan.name.slice(
                            0,
                            8
                          )}...${documents.pan.name.slice(
                            documents.pan.name.lastIndexOf(".") - 3,
                            documents.pan.name.lastIndexOf(".")
                          )}${documents.pan.name.slice(
                            documents.pan.name.lastIndexOf(".")
                          )}`
                        : documents.pan.name}
                    </p>
                  </div>
                  <div
                    className={`kyc-tag ${
                      kyc?.panStatus === "1"
                        ? "approved"
                        : kyc?.panStatus === "0" && kyc?.panImg
                        ? "rejected"
                        : kyc?.panStatus === "2"
                        ? "pending"
                        : ""
                    }`}
                  >
                    {kyc?.panStatus === "1"
                      ? "Approved"
                      : kyc?.panStatus === "0" && kyc?.panImg
                      ? "Rejected"
                      : kyc?.panStatus === "2"
                      ? "Pending"
                      : ""}
                  </div>
                </>
              )}
            </div>
            {errors.panNumber && (
              <span className="validation-error-message">
                {errors.panNumber.message}
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="aadharNumber"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            <label style={{ color: "red" }}>*</label> Aadhar Number:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <div className="d-flex flex-wrap align-items-start gap-2">
              <div className="flex-grow-1">
                <input
                  {...register("aadharNumber", {
                    required: t("this_field_is_required"),
                    pattern: {
                      value: /^\d{12}$/,
                      message: "Aadhar must be 12 Digits Only", // Customize/localize this message
                    },
                  })}
                  name="aadharNumber"
                  type="number"
                  className="form-control no-spinner w-100"
                  id="aadharNumber"
                  defaultValue={formValues?.aadharNumber}
                  disabled={!isEditModeEnabled}
                />
              </div>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="aadhaar-upload"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "aadhaar")}
                />
                <label
                  htmlFor="aadhaar-upload"
                  style={{
                    cursor:
                      !isEditModeEnabled ||
                      kyc?.aadhaarStatus === "1" ||
                      kyc?.aadhaarStatus === "2"
                        ? "not-allowed"
                        : "pointer",
                    padding: "6px 20px",
                    background:
                      !isEditModeEnabled ||
                      kyc?.aadhaarStatus === "1" ||
                      kyc?.aadhaarStatus === "2"
                        ? "gray"
                        : "#954cea",
                    color: "#fff",
                    borderRadius: "5px",
                    opacity:
                      !isEditModeEnabled ||
                      kyc?.aadhaarStatus === "1" ||
                      kyc?.aadhaarStatus === "2"
                        ? 0.6
                        : 1,
                    pointerEvents:
                      !isEditModeEnabled ||
                      kyc?.aadhaarStatus === "1" ||
                      kyc?.aadhaarStatus === "2"
                        ? "none"
                        : "auto",
                  }}
                >
                  <i class="fa-solid fa-upload"></i>
                </label>
              </div>
              {documents.aadhaar.file && (
                <>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={documents.aadhaar.file}
                      style={{ width: "36px", height: "auto" }}
                    />
                    <p className="mt-2">
                      {documents.aadhaar.name.length > 20
                        ? `${documents.aadhaar.name.slice(
                            0,
                            8
                          )}...${documents.aadhaar.name.slice(
                            documents.aadhaar.name.lastIndexOf(".") - 3,
                            documents.aadhaar.name.lastIndexOf(".")
                          )}${documents.aadhaar.name.slice(
                            documents.aadhaar.name.lastIndexOf(".")
                          )}`
                        : documents.aadhaar.name}
                    </p>
                  </div>
                  <div
                    className={`kyc-tag ${
                      kyc?.aadhaarStatus === "1"
                        ? "approved"
                        : kyc?.aadhaarStatus === "0" && kyc?.aadhaarImg
                        ? "rejected"
                        : kyc?.aadhaarStatus === "2"
                        ? "pending"
                        : ""
                    }`}
                  >
                    {kyc?.aadhaarStatus === "1"
                      ? "Approved"
                      : kyc?.aadhaarStatus === "0" && kyc?.aadhaarImg
                      ? "Rejected"
                      : kyc?.aadhaarStatus === "2"
                      ? "Pending"
                      : ""}
                  </div>
                </>
              )}
            </div>
            {errors.aadharNumber && (
              <span className="validation-error-message">
                {errors.aadharNumber.message}
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="gstin"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            GSTIN:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <div className="d-flex flex-wrap align-items-start gap-2">
              <div className="flex-grow-1">
                <input
                  {...register("gstin", {
                    // required: t("this_field_is_required"),
                    // validate: {
                    //   notEmpty: (value) =>
                    //     value.trim() !== "" || t("this_field_is_required"),
                    //   // onlyNumber: (value) =>
                    //   //   /^\d+$/.test(value) || t("only_number"),
                    // },
                  })}
                  name="gstin"
                  type="text"
                  className="form-control w-100"
                  id="gstin"
                  defaultValue={formValues?.gstin}
                  disabled={!isEditModeEnabled}
                />
              </div>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="gstin-upload"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "gstin")}
                />
                <label
                  htmlFor="gstin-upload"
                  style={{
                    cursor:
                      !isEditModeEnabled ||
                      kyc?.gstinStatus === "1" ||
                      kyc?.gstinStatus === "2"
                        ? "not-allowed"
                        : "pointer",
                    padding: "6px 20px",
                    background:
                      !isEditModeEnabled ||
                      kyc?.gstinStatus === "1" ||
                      kyc?.gstinStatus === "2"
                        ? "gray"
                        : "#954cea",
                    color: "#fff",
                    borderRadius: "5px",
                    opacity:
                      !isEditModeEnabled ||
                      kyc?.gstinStatus === "1" ||
                      kyc?.gstinStatus === "2"
                        ? 0.6
                        : 1,
                    pointerEvents:
                      !isEditModeEnabled ||
                      kyc?.gstinStatus === "1" ||
                      kyc?.gstinStatus === "2"
                        ? "none"
                        : "auto",
                  }}
                >
                  <i class="fa-solid fa-upload"></i>
                </label>
              </div>
              {documents.gstin.file && (
                <>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={documents.gstin.file}
                      style={{ width: "36px", height: "auto" }}
                    />
                    <p className="mt-2">
                      {documents.gstin.name.length > 20
                        ? `${documents.gstin.name.slice(
                            0,
                            8
                          )}...${documents.gstin.name.slice(
                            documents.gstin.name.lastIndexOf(".") - 3,
                            documents.gstin.name.lastIndexOf(".")
                          )}${documents.gstin.name.slice(
                            documents.gstin.name.lastIndexOf(".")
                          )}`
                        : documents.gstin.name}
                    </p>
                  </div>
                  <div
                    className={`kyc-tag ${
                      kyc?.gstinStatus === "1"
                        ? "approved"
                        : kyc?.gstinStatus === "0" && kyc?.gstinImg
                        ? "rejected"
                        : kyc?.gstinStatus === "2"
                        ? "pending"
                        : ""
                    }`}
                  >
                    {kyc?.gstinStatus === "1"
                      ? "Approved"
                      : kyc?.gstinStatus === "0" && kyc?.gstinImg
                      ? "Rejected"
                      : kyc?.gstinStatus === "2"
                      ? "Pending"
                      : ""}
                  </div>
                </>
              )}
            </div>
            {errors.gstin && (
              <span className="validation-error-message">
                {errors.gstin.message}
              </span>
            )}
          </div>
        </div>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="gstin"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            <label style={{ color: "red" }}>*</label> Bank Passbook:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <div className="d-flex flex-wrap align-items-start gap-2">
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="bank-upload"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "bankPassbook")}
                />
                <label
                  htmlFor="bank-upload"
                  style={{
                    cursor:
                      !isEditModeEnabled ||
                      kyc?.bankPassbookStatus === "1" ||
                      kyc?.bankPassbookStatus === "2"
                        ? "not-allowed"
                        : "pointer",
                    padding: "6px 50px",
                    background:
                      !isEditModeEnabled ||
                      kyc?.bankPassbookStatus === "1" ||
                      kyc?.bankPassbookStatus === "2"
                        ? "gray"
                        : "#954cea",
                    color: "#fff",
                    borderRadius: "5px",
                    opacity: !isEditModeEnabled ? 0.6 : 1,
                    pointerEvents:
                      !isEditModeEnabled ||
                      kyc?.bankPassbookStatus === "1" ||
                      kyc?.bankPassbookStatus === "2"
                        ? "none"
                        : "auto",
                  }}
                >
                  <span className="upload-text">Upload Image</span>{" "}
                  <i class="fa-solid fa-upload"></i>
                </label>
              </div>
              {documents.bankPassbook.file && (
                <>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={documents.bankPassbook.file}
                      style={{ width: "36px", height: "auto" }}
                    />
                    <p className="mt-2">
                      {documents.bankPassbook.name.length > 20
                        ? `${documents.bankPassbook.name.slice(
                            0,
                            8
                          )}...${documents.bankPassbook.name.slice(
                            documents.bankPassbook.name.lastIndexOf(".") - 3,
                            documents.bankPassbook.name.lastIndexOf(".")
                          )}${documents.bankPassbook.name.slice(
                            documents.bankPassbook.name.lastIndexOf(".")
                          )}`
                        : documents.bankPassbook.name}
                    </p>
                  </div>
                  <div
                    className={`kyc-tag ${
                      kyc?.bankPassbookStatus === "1"
                        ? "approved"
                        : kyc?.bankPassbookStatus === "0" && kyc?.bankPassbookImg
                        ? "rejected"
                        : kyc?.bankPassbookStatus === "2"
                        ? "pending"
                        : ""
                    }`}
                  >
                    {kyc?.bankPassbookStatus === "1"
                      ? "Approved"
                      : kyc?.bankPassbookStatus === "0" && kyc?.bankPassbookImg
                      ? "Rejected"
                      : kyc?.bankPassbookStatus === "2"
                      ? "Pending"
                      : ""}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="mb-3 row tabBlockClass">
          <label
            htmlFor="gstin"
            className="col-sm-3 col-form-label labelWidthClass"
          >
            Signature:
          </label>
          <div className="col-md-9 col-sm-12 col-12">
            <div className="d-flex flex-wrap align-items-start gap-2">
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="signature-upload"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "signature")}
                />
                <label
                  htmlFor="signature-upload"
                  style={{
                    cursor:
                      !isEditModeEnabled ||
                      kyc?.signatureStatus === "1" ||
                      kyc?.signatureStatus === "2"
                        ? "not-allowed"
                        : "pointer",
                    padding: "6px 50px",
                    background:
                      !isEditModeEnabled ||
                      kyc?.signatureStatus === "1" ||
                      kyc?.signatureStatus === "2"
                        ? "gray"
                        : "#954cea",
                    color: "#fff",
                    borderRadius: "5px",
                    opacity: !isEditModeEnabled ? 0.6 : 1,
                    pointerEvents:
                      !isEditModeEnabled ||
                      kyc?.signatureStatus === "1" ||
                      kyc?.signatureStatus === "2"
                        ? "none"
                        : "auto",
                  }}
                >
                  <span className="upload-text">Upload Image</span>{" "}
                  <i class="fa-solid fa-upload"></i>
                </label>
              </div>
              {documents.signature.file && (
                <>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={documents.signature.file}
                      style={{ width: "36px", height: "auto" }}
                    />
                    <p className="mt-2">
                      {documents.signature.name.length > 20
                        ? `${documents.signature.name.slice(
                            0,
                            8
                          )}...${documents.signature.name.slice(
                            documents.signature.name.lastIndexOf(".") - 3,
                            documents.signature.name.lastIndexOf(".")
                          )}${documents.signature.name.slice(
                            documents.signature.name.lastIndexOf(".")
                          )}`
                        : documents.signature.name}
                    </p>
                  </div>
                  <div
                    className={`kyc-tag ${
                      kyc?.signatureStatus === "1"
                        ? "approved"
                        : kyc?.signatureStatus === "0" && kyc?.signatureImg
                        ? "rejected"
                        : kyc?.signatureStatus === "2"
                        ? "pending"
                        : ""
                    }`}
                  >
                    {kyc?.signatureStatus === "1"
                      ? "Approved"
                      : kyc?.signatureStatus === "0" && kyc?.signatureImg
                      ? "Rejected"
                      : kyc?.signatureStatus === "2"
                      ? "Pending"
                      : ""}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="tabcontent_form_section" style={{maxWidth: "750px"}}>
          <div className="mb-3 row tabBlockClass">
            <label
              htmlFor="panName"
              className="col-sm-3 col-form-label labelWidthClass"
            >
              <label style={{ color: "red" }}>*</label> Email:
            </label>
            <div className="col-md-9 col-sm-12 col-12">
              <div className="d-flex flex-wrap align-items-start gap-2">
                <div className="flex-grow-1">
                  <input
                    {...register("email", {
                      required: t("this_field_is_required"),
                      validate: (value) =>
                        value.trim() !== "" || t("this_field_is_required"),
                      pattern: {
                        value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/,
                        message: t("invalid_email_format"),
                      },
                    })}
                    name="email"
                    type="text"
                    className="form-control w-100"
                    // style={{ width: "52.3%" }}
                    id="email"
                    defaultValue={formValues?.email}
                    disabled={!isEditModeEnabled || emailVerified || verifyEmail.data?.status}
                  />
                  {errors.email && (
                    <span className="validation-error-message">
                      {errors.email.message}
                    </span>
                  )}
                </div>
                <button
                  className={` btn ${
                    verifyEmail.data?.status || emailVerified
                      ? "btn-success bg-success"
                      : !isEditModeEnabled ? "btn-secondary" : "btn-primary"
                  } `}
                  onClick={sendVerificationCode}
                  // style={verifyEmail.data?.status ? {pointerEvents: "none"} : {}}
                  disabled={
                    formValues.email === "" ||
                    !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/.test(
                      formValues.email
                    ) ||
                    sendEmailVerification.isLoading ||
                    verifyEmail.data?.status || emailVerified
                  }
                >
                  {sendEmailVerification.isLoading ? (
                    <i class="fa-solid fa-circle-notch fa-spin px-3"></i>
                  ) : isOtpSend ? (
                    <>
                      <i class="fa-solid fa-repeat"></i> Resend
                    </>
                  ) : verifyEmail.data?.status || emailVerified ? (
                    <>
                      <i class="fa-solid fa-circle-check"></i> Verified
                    </>
                  ) : (
                    <>
                      <i class="fa-solid fa-paper-plane"></i> Verify
                    </>
                  )}
                </button>
              </div>
            {isOtpSend &&
              <div>
                <input type="text" maxLength={6} className="form-control" placeholder="Enter Verification Code" style={{ width: "40%" }} disabled={!isOtpSend} onChange={handleVerificationCodeChange} />
              </div>
              }
            </div>
          </div>
        </div>
        {kycStatus != 1 && !isKycPending && (
          <div
            className={`paymenytLinkBtn ${isEditModeEnabled ? "disabled" : ""}`}
          >
            <SubmitButton
              className="btn"
              isSubmitting={updateKycMutation.isLoading || !isEditModeEnabled}
              text={updateKycMutation.isLoading ? "updating..." : "update"}
              click={handleSubmit}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default KycTab;
